import {Directive, OnInit, EventEmitter} from "@angular/core";


export class OnInitDirective implements OnInit {
    onInitChange: EventEmitter<InitEvent> = new EventEmitter<InitEvent>();

    ngOnInit (): void {
        this.onInitChange.emit({time: new Date()});
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    outputs: ["onInitChange: a2OnInit"],
    selector: "[a2OnInit]",
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

export interface InitEvent {
    time: Date;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
